import { render, staticRenderFns } from "./ManualUsuario.vue?vue&type=template&id=4d413cbe"
import script from "./ManualUsuario.vue?vue&type=script&lang=js"
export * from "./ManualUsuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d413cbe')) {
      api.createRecord('4d413cbe', component.options)
    } else {
      api.reload('4d413cbe', component.options)
    }
    module.hot.accept("./ManualUsuario.vue?vue&type=template&id=4d413cbe", function () {
      api.rerender('4d413cbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ManualUsuario.vue"
export default component.exports